module.exports = __webpack_public_path__ + "img/Datasecurity.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Datasecurity.svg
// module id = 248
// module chunks = 0